/* Cart drawer – upsell carousel + quick add */
(() => {
  if (window.__cdxInit) return;
  window.__cdxInit = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Variant change -> update upsell price
  document.addEventListener('change', (e) => {
    const select = e.target.closest('.cdx-drawer select[data-cdx-variant]');
    if (!select) return;
    const card = select.closest('[data-cdx-upsell]');
    const opt = select.selectedOptions[0];
    if (!card || !opt) return;
    const price = card.querySelector('[data-cdx-price]');
    const compare = card.querySelector('[data-cdx-compare]');
    if (price) price.textContent = opt.dataset.price || '';
    if (compare) {
      compare.textContent = opt.dataset.compare || '';
      compare.hidden = !opt.dataset.compare;
    }
  });

  document.addEventListener('click', async (e) => {
    // Carousel arrows
    const nav = e.target.closest('.cdx-drawer [data-cdx-nav]');
    if (nav) {
      e.preventDefault();
      const track = nav.parentElement.querySelector('[data-cdx-track]');
      if (!track) return;
      const dir = parseInt(nav.dataset.cdxNav, 10);
      const max = track.scrollWidth - track.clientWidth;
      let target = track.scrollLeft + dir * track.clientWidth;
      if (target > max + 2) target = 0;          // loop to start
      else if (target < -2) target = max;        // loop to end
      track.scrollTo({ left: target, behavior: 'smooth' });
      return;
    }

    // Quick add upsell
    const add = e.target.closest('.cdx-drawer [data-cdx-add]');
    if (!add) return;
    e.preventDefault();
    const card = add.closest('[data-cdx-upsell]');
    const input = card && card.querySelector('[data-cdx-variant]');
    if (!input || !input.value) return;

    add.disabled = true;
    const label = add.textContent;
    add.textContent = '…';
    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add item');
      }
      // Symmetry listens to this: refreshes cart-form + header count
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } catch (err) {
      add.textContent = label;
      add.disabled = false;
      if (window.theme && typeof theme.showQuickPopup === 'function') {
        theme.showQuickPopup(err.message, add);
      } else {
        alert(err.message);
      }
    }
  });
})();
